import axios from "axios";
import { createAxiosRequestInterceptors } from "./axios-interceptors";

const authAxios = axios.create();

createAxiosRequestInterceptors(authAxios);

export default authAxios;
